export function ordenarPorTexto<T>(
  lista: T[] | null | undefined,
  campo: keyof T
): T[] {
  return [...(Array.isArray(lista) ? lista : [])].sort((a, b) =>
    String(a[campo] ?? "").localeCompare(String(b[campo] ?? ""), "pt-BR", { sensitivity: "base" })
  );
}
